export default __webpack_public_path__ + "approved-icon.svg";